import Vue from 'vue'
import store from 'store'
import qs from 'qs'

export default {
    endStep(rootState, instanceId, currentStep, nextStep, callbacks) {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "Le changement d'étape a échoué.",
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "currentStep": currentStep,
            "nextStep": nextStep
        })});

        Vue.axios.post(rootState.baseUrl + "/user/instance/" + instanceId + "/end-step", params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    }
};